import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileType3D = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 13.5l4 -1.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12v4.2l4 1.8" })
	]
});
const ForwardRef = forwardRef(SvgFileType3D);
export default ForwardRef;
